import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILCONTRACT,
  DELETE_CIVILCONTRACT,
  UPDATE_CIVILCONTRACT,
  ADD_NEW_CIVILCONTRACT,
} from "./actionType";

import {
  getCivilContractSuccess,
  getCivilContractFail,
  deleteCivilContractSuccess,
  deleteCivilContractFail,
  updateCivilContractSuccess,
  updateCivilContractFail,
  addCivilContractSuccess,
  addCivilContractFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilContractApi,
  updateCivilContractApi,
  deleteCivilContractApi,
  addNewCivilContractApi,
  approveCivilContractApi
} from "../../helpers/backend_helper";

function* getCivilContract({ payload: civilContract }) {
  try {
    const response = yield call(getCivilContractApi, civilContract);
    yield put(getCivilContractSuccess(GET_CIVILCONTRACT, response.data));
  } catch (error) {
    yield put(getCivilContractFail(GET_CIVILCONTRACT, error));
  }
}

function* onUpdateCivilContract({ payload: civilContract }) {
  try {
    if (civilContract.setApprove) {
      const response = yield call(approveCivilContractApi, civilContract);
      yield put(updateCivilContractSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilContractApi, civilContract);
      yield put(updateCivilContractSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilContractFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilContract({ payload: civilContract }) {
  try {
    const response = yield call(deleteCivilContractApi, civilContract);
    yield put(deleteCivilContractSuccess({ civilContract, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilContractFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilContract({ payload: civilContract }) {
  try {
    const response = yield call(addNewCivilContractApi, civilContract);
    yield put(addCivilContractSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilContractFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilContract() {
  yield takeEvery(GET_CIVILCONTRACT, getCivilContract);
}

export function* watchUpdateCivilContract() {
  yield takeEvery(UPDATE_CIVILCONTRACT, onUpdateCivilContract);
}

export function* watchDeleteCivilContract() {
  yield takeEvery(DELETE_CIVILCONTRACT, onDeleteCivilContract);
}

export function* watchAddNewCivilContract() {
  yield takeEvery(ADD_NEW_CIVILCONTRACT, onAddNewCivilContract);
}

function* civilContractSaga() {
  yield all([
    fork(watchGetCivilContract),
    fork(watchDeleteCivilContract),
    fork(watchUpdateCivilContract),
    fork(watchAddNewCivilContract)
  ]);
}

export default civilContractSaga;
